import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const trackPage = async () => {
      try {
        const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192');
        const apiUrl = isLocal ? `http://${window.location.hostname}:3001/api/stats/visit` : '/api/stats/visit';
        
        await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ page: location.pathname })
        });
      } catch (error) {
        // İstatistik hatası kullanıcı deneyimini etkilememeli, sadece konsola yazalım (veya sessiz kalalım)
        console.error('Tracking error:', error);
      }
    };

    trackPage();
  }, [location]);

  return null; // Görünmez bileşen
};

export default PageTracker;